<div class="benchmark-toggle-section">
	<dz-toggle-switch
		[toggleOn]="includeBenchmark"
		[toggleLabel]="'Include Benchmark' | dcr: 'PDF_GENERATE_BENCHMARK_HEADER'"
		[dcrKeys]="['PDF_GENERATE_BENCHMARK_HEADER']"
		(click)="toggleBenchmark()"
		custom-tracking
		[track-event]="'pdf-logo-upload:include-benchmark-toggle:' + (!includeBenchmark ? 'on' : 'off')"
	>
	</dz-toggle-switch>
</div>
